var _path, _circle, _circle2, _circle3, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroUbuntuRunningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_136_6",
    "data-name": "Component 136 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.582,
    height: 138.894,
    viewBox: "0 0 148.582 138.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M151.983,121.2V25.613c0-12.489-4.895-18.294-15.651-18.294H19.476C8.72,7.319,3.4,13.124,3.4,25.613V121.2H71.412V134.55H45.444v11.663h64.92V134.55H84.4V121.2Zm-139-95.59c0-4.163,2.907-7.538,6.492-7.538H136.331c3.585,0,6.492,3.375,6.492,7.538v82.913H12.984Z",
    transform: "translate(-3.401 -7.319)",
    fill: "#8cbe7f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 8.246,
    cy: 8.246,
    r: 8.246,
    transform: "translate(33.916 48.755)",
    fill: "#ff5722"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 8.246,
    cy: 8.246,
    r: 8.246,
    transform: "translate(88.327 80.088)",
    fill: "#ff5722"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 8.246,
    cy: 8.246,
    r: 8.246,
    transform: "translate(88.327 17.421)",
    fill: "#ff5722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M223.931,58.962a1.649,1.649,0,0,0,1.831.775,16.4,16.4,0,0,1,19.882,11.475,1.649,1.649,0,0,0,1.586,1.2h13.477a1.649,1.649,0,0,0,1.65-1.648,1.667,1.667,0,0,0-.021-.261,32.9,32.9,0,0,0-7.5-16.231,1.649,1.649,0,0,0-2.164-.29,11.533,11.533,0,0,1-17.932-9.446,1.649,1.649,0,0,0-1.474-1.616,33.082,33.082,0,0,0-15.254,2,1.649,1.649,0,0,0-.838,2.365Z",
    transform: "translate(-149.701 -18.71)",
    fill: "#ff5722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M260.821,277.333H247.344a1.649,1.649,0,0,0-1.586,1.2,16.389,16.389,0,0,1-19.882,11.475,1.649,1.649,0,0,0-1.831.775L217.3,302.462a1.649,1.649,0,0,0,.838,2.365,32.569,32.569,0,0,0,15.254,2,1.649,1.649,0,0,0,1.474-1.616,11.517,11.517,0,0,1,17.913-9.446,1.649,1.649,0,0,0,2.167-.3,32.9,32.9,0,0,0,7.5-16.221,1.649,1.649,0,0,0-1.368-1.889A1.679,1.679,0,0,0,260.821,277.333Z",
    transform: "translate(-149.812 -217.035)",
    fill: "#ff5722"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M117.226,125.642a16.458,16.458,0,0,1,0-22.966,1.649,1.649,0,0,0,.244-1.979l-6.732-11.653a1.649,1.649,0,0,0-1.131-.8,1.721,1.721,0,0,0-1.339.33,33.009,33.009,0,0,0-10.4,14.892,1.649,1.649,0,0,0,.511,1.811,11.362,11.362,0,0,1,0,17.767,1.649,1.649,0,0,0-.511,1.811,33.01,33.01,0,0,0,10.393,14.878,1.649,1.649,0,0,0,1.042.369,1.8,1.8,0,0,0,.3-.026,1.649,1.649,0,0,0,1.131-.8l6.732-11.659A1.649,1.649,0,0,0,117.226,125.642Z",
    transform: "translate(-48.956 -57.16)",
    fill: "#ff5722"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroUbuntuRunningIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroUbuntuRunningIcon.0ca6c2a8474a2fa2a9ad74e6efd3becb.svg";
export { ForwardRef as ReactComponent };